export default {
  hidden_rates:
    'Für einige Zahlungsarten gilt außerdem ein eigener Satz, den Ihr Plattform-Support festgelegt hat. Er gilt dort anstelle dieses Satzes.',
  title: 'Verarbeitungsgebühren',
  subtitle:
    'Die Verarbeitungsgebühr, die {{company}} für Online-Zahlungen berechnet wird, um die Stripe-Gebühren zu decken.',
  card_title: 'Verarbeitungsgebühr',
  status: {
    inherited_tag: 'Partner-Standard',
    inherited: 'Diesem Restaurant wird Ihre Standard-Verarbeitungsgebühr berechnet.',
    custom_tag: 'Individuell',
    custom: 'Dieses Restaurant hat eine eigene Verarbeitungsgebühr, die Ihren Standard ersetzt.',
    none_title: 'Keine Verarbeitungsgebühr festgelegt',
    none: 'Weder dieses Restaurant noch Ihr Standard hat einen Satz. Ohne Ihre Bestätigung einer Marge von 0 % auf der Partnerseite für Verarbeitungsgebühren kann es nicht live gehen und keine Online-Zahlungen annehmen; mit dieser Bestätigung wird ihm nichts berechnet, und Sie tragen die Stripe-Gebühren für seine Zahlungen.',
  },
  buttons: {
    set_custom: 'Eigene Gebühr festlegen',
    edit: 'Bearbeiten',
    cancel: 'Abbrechen',
    save: 'Speichern',
    reset_to_default: 'Auf Standard zurücksetzen',
  },
  toasts: {
    load_error: 'Die Verarbeitungsgebühr konnte nicht geladen werden.',
    failed_to_save_changes: 'Die Verarbeitungsgebühr konnte nicht gespeichert werden.',
    changes_got_saved: 'Verarbeitungsgebühr gespeichert',
    reset_to_default: 'Dieses Restaurant verwendet jetzt Ihre Standard-Verarbeitungsgebühr.',
  },
};
